import React from "react";

import { Table } from "react-bootstrap";

const ContractOverViewCard = (props) => {
  const { startDate, endDate, mgmtModel, duration, numInstallment } = props;

  return (
    <div className="deposit-list">
      <h3 className="table-section-heading font_m fw_6">Contract</h3>
      <div className="custom-table-wrapper">
        <Table className="custom-table font_s" borderless responsive>
          {/* Table Heading */}
          <thead>
            <tr>
              <th className=""><p className="font_s fw_6 font_grey">Label</p></th>
              <th className="">
                <p className="font_s fw_6 font_grey">Value</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="install">
              <td>
                <p className="font_s fw_5">Contract Start Date</p>
              </td>

              <td className="amount-column-wrapper">
                <p className="font_s fw_5">{startDate}</p>
              </td>
            </tr>
            <tr className="install">
              <td>
                <p className="font_s fw_5">Contract End Date</p>
              </td>

              <td className="amount-column-wrapper">
                <p className="font_s fw_5">{endDate}</p>
              </td>
            </tr>
            <tr className="install">
              <td>
                <p className="font_s fw_5">Contract Duration</p>
              </td>

              <td className="amount-column-wrapper">
                <p className="font_s fw_5">{duration} {mgmtModel === 3 ? "Days" : "Months"}</p>
              </td>
            </tr>
            <tr className="install">
              <td>
                <p className="font_s fw_5">Number Of Installments</p>
              </td>

              <td className="amount-column-wrapper">
                <p className="font_s fw_5">{numInstallment}</p>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ContractOverViewCard;
